<script lang="ts">
	//UI
	import StoreDetailViewer from "../component/Store/StoreDetailViewer.svelte";
	import StoreMemo from "../component/Store/StoreMemo.svelte";
	//Utils
	import { api, t } from "@hitit/hub/src/stores";
	//Types
	import type { StoreData } from "@hitit/api";
	import ContainerLoading from "@hitit/hub/src/v7/components/common/ContainerLoading.svelte";
	import { onDestroy } from "svelte";
	import { popup } from "@hitit/hub/src/v7/store";
	import SelfOrderManage from "../component/Store/SelfOrder/SelfOrderManage.svelte";
	//Props
	export let storeId = "";
	//Constants
	//Variables
	let store: StoreData | undefined;
	let storeMemo: string | undefined;
	let loading = false;
	//Functions
	async function loadData(storeId: string) {
		try {
			loading = true;
			const [adminCommentResponse, storeResponse] = await Promise.all([
				$api.getAdminComments(storeId),
				$api.getStore(storeId),
			]);

			const gettedStore = storeResponse.data.result.find(
				(v) => v.id === storeId
			) as StoreData;
			const sorttedComment =
				adminCommentResponse.data.storeAdminCommentDTOS.sort((a, b) => {
					const aDate = new Date(a.lastUpdated || "").getTime();
					const bDate = new Date(b.lastUpdated || "").getTime();
					return bDate - aDate;
				});
			storeMemo = sorttedComment.length === 0 ? "" : sorttedComment[0].content;
			store = gettedStore;
			loading = false;
		} catch (error) {
			store = undefined;
			storeMemo = undefined;
			alert($t("sso.error.unknownError"));
			console.log(error);
		} finally {
			loading = false;
		}
	}

	//Do
	$: loadData(storeId);

	onDestroy(() => {
		$popup = undefined;
	});
</script>

{#if loading}
	<ContainerLoading />
{/if}
{#if store && storeMemo !== undefined}
	<div class="container" t-id="ManageStore">
		<div class="left-contents">
			<StoreDetailViewer store={store} />
		</div>
		<div class="right-contents">
			<div class="container-wrapper">
				<StoreMemo storeId={storeId} text={storeMemo} />
			</div>
			<!-- 셀프오더 기능 완성 후 주석제거 -->
			<!-- <div class="container-wrapper"><SelfOrderManage storeId={storeId} /></div> -->
		</div>
	</div>
{/if}

<style lang="scss">
	@import "../../variables.scss";
	.container {
		display: flex;
		padding-top: 60px;
		flex-direction: column;
		gap: 20px;

		.left-contents {
		}

		.right-contents {
			display: flex;
			flex-direction: column;
			gap: 20px;
		}
	}

	@include DesktopSize {
		.container {
			flex-direction: row;
			padding-top: 30px;

			.left-contents {
				width: 55%;
				.container-wrapper {
					/* height: auto; */
				}
			}

			.right-contents {
				width: 45%;
			}

			@media screen and (max-width: 1520px) {
				flex-direction: column;

				.left-contents,
				.right-contents {
					width: 100%;
				}
			}
		}
	}
</style>
